/* eslint-disable */
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

var ga = window.ga
ga('create', 'UA-36291841-2', 'auto');
ga('set', 'anonymizeIp', true);
ga('send', 'pageview');


export default ga



// WEBPACK FOOTER //
// ./src/analytics.js